import styled from 'styled-components';

// export const ModalWrapper = styled.div`
//   position: fixed; /* Vollständig vom Viewport abhängig */
//   top: 0;
//   left: 0;
//   width: 100vw;
//   height: 100vh;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background-color: rgba(0, 0, 0, 0.5); /* halbtransparenter Overlay */
//   z-index: 110;
// `;

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9); 
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 110;
`;

export const ModalContent = styled.div`
  background-color: burlywood;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.8); 
  z-index: 111;
  /* max-width: 400px; */
  /* width: 100%; */
  opacity: 1;
  box-sizing: border-box;
`;

export const Title = styled.h2`
  text-align: center;
  color: black;
  width: 160px; 
  margin: 0 auto; 
  word-wrap: break-word; 
  overflow-wrap: break-word; 
  hyphens: auto; 
`;

export const Text = styled.p`
  color: blueviolet;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  font-size: 1rem;
  max-width: 13rem;
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
`;

export const StyledButton = styled.button`
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.8rem;
  height: 2rem;
  width: 6rem;
  ${(props) =>
    props.primary
      ? `
    background-color:rgb(22, 161, 68);
    color: white;
  `
      : `
    background-color:rgb(238, 45, 45);
    color: black;
  `}
`;
